import { BordTabsGroupWithBadge } from 'bord-design-system';
import { EQuoteStatus, TQuotesCountByStatus } from 'types/quote.types';

type TBordTabsGroupWithBadgeProps = Parameters<typeof BordTabsGroupWithBadge>[0];

export const getTabs = (countByStatus: TQuotesCountByStatus): TBordTabsGroupWithBadgeProps['tabs'] => {
  return [
    {
      value: EQuoteStatus.TO_QUOTE,
      label: 'Por cotizar',
      textColor: 'warning',
      badge: {
        label: countByStatus?.[EQuoteStatus.TO_QUOTE] ?? 0
      }
    },
    {
      value: EQuoteStatus.PENDING_APPROVAL,
      label: 'Pendiente de aprobación',
      textColor: 'informative',

      badge: {
        label: countByStatus?.[EQuoteStatus.PENDING_APPROVAL] ?? 0
      }
    },
    {
      value: EQuoteStatus.PURCHASED,
      label: 'Compradas',
      textColor: 'success',

      badge: {
        label: countByStatus?.[EQuoteStatus.PURCHASED] ?? 0
      }
    },
    {
      value: EQuoteStatus.EXPIRED,
      label: 'Vencidas',
      textColor: 'danger',

      badge: {
        label: countByStatus?.[EQuoteStatus.EXPIRED] ?? 0
      }
    },
    {
      value: EQuoteStatus.REJECTED,
      label: 'Canceladas',
      textColor: 'danger',
      badge: {
        label: countByStatus?.[EQuoteStatus.REJECTED] ?? 0
      }
    }
  ];
};
